import { Brain, Layout } from "lucide-react";

export default function About() {
    return (
        <section id="about" className="py-24 bg-background border-t border-border/40">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
                    {/* Left Column: Image */}
                    <div className="relative group">
                        <div className="relative aspect-square rounded-2xl overflow-hidden bg-muted">
                            <img
                                src="/img/about2.jpg"
                                alt="Musab Digale"
                                className="object-cover w-full h-full grayscale hover:grayscale-0 transition-all duration-500"
                            />
                            <div className="absolute inset-0 bg-neon/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none mix-blend-multiply" />
                        </div>

                        {/* Floating Badge */}
                        <div className="absolute bottom-6 right-4 bg-card border border-border p-4 rounded-xl shadow-xl flex items-center gap-4 animate-bounce-slow">
                            <div className="bg-neon text-black font-bold text-xl px-3 py-1 rounded">3+</div>
                            <div className="text-sm font-medium leading-tight">
                                YEARS<br />EXPERIENCE
                            </div>
                        </div>
                    </div>

                    {/* Right Column: Content */}
                    <div>
                        <div className="flex items-center gap-2 mb-6">
                            <span className="w-12 h-[1px] bg-neon"></span>
                            <span className="text-sm font-bold tracking-widest uppercase text-muted-foreground">About Me</span>
                        </div>
                        <h2 className="text-4xl font-bold mb-6 leading-tight">
                            Musab Ali <span className="text-neon bg-black px-1">Digaale.</span>
                        </h2>
                        <p className="text-muted-foreground mb-8 text-lg leading-relaxed">
                            <b>I’m Musab Digale</b>, a Software Developer and AI Automation Engineer specializing in Technology & Business (TechBusiness). I build scalable digital systems that combine clean design, strong architecture, and intelligent automation to solve real business problems.

                            I’m the <b>Co-Founder</b> of <b>Digale Advert</b> (est. 2020), where I serve as Tech Manager and a member of the founding team in <b>Hormariye Tech</b>. I’m also an <b>entrepreneur</b>, currently preparing to launch a new venture called <b>Goox Store</b>.
                        </p>

                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                            <div className="p-4 rounded-lg bg-secondary/50 border border-secondary">
                                <Layout className="w-8 h-8 text-neon mb-3" />
                                <h4 className="font-bold mb-2">Vision</h4>
                                <p className="text-sm text-muted-foreground">To empower businesses with innovative, scalable TechBusiness systems driven by smart automation and modern technology.</p>
                            </div>
                            <div className="p-4 rounded-lg bg-secondary/50 border border-secondary">
                                <Brain className="w-8 h-8 text-neon mb-3" />
                                <h4 className="font-bold mb-2">Strategy</h4>
                                <p className="text-sm text-muted-foreground">Using data-driven insights and AI automation to build efficient, high-performance solutions aligned with business goals.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
